import { PlaceholdersReplacements } from '../../../../../hooks/usePlaceholdersReplacements';

import {
	Discord,
	Email,
	Telegram,
	Twitter,
	Link as LinkIcon,
	Open,
} from '@drift-labs/icons';
import { cm } from 'src/utils/classNames';
import { OverviewSection } from '../../../../../@types/vaults';
import { Placeholders } from '../../../../../constants/vaults/misc';
import Link from 'src/components/primitives/Link/Link';

export const getVaultContactIconFromUrl = (url: string) => {
	const isEmail = url.includes('mailto:');
	const isTelegram = url.includes('t.me');
	const isTwitter = url.includes('x.com') || url.includes('twitter.com');
	const isDiscord = url.includes('discord.gg');

	if (isEmail) return Email;
	if (isTelegram) return Telegram;
	if (isTwitter) return Twitter;
	if (isDiscord) return Discord;

	return LinkIcon;
};

export const Section = ({
	section,
	placeholdersReplacements,
}: {
	section: OverviewSection;
	placeholdersReplacements: PlaceholdersReplacements;
}) => {
	const placeholders = Object.keys(placeholdersReplacements);

	return (
		<div className="flex w-full flex-col">
			<span className="mb-4 typo-t3 text-text-default">{section.title}</span>
			<div className="flex w-full flex-col gap-4">
				{section.paragraphs.map((paragraph, index) => (
					<span
						className={cm('typo-t4 text-text-secondary', paragraph.className)}
						key={index}
					>
						{paragraph.contacts ? (
							<div className="flex flex-wrap items-center gap-4">
								{paragraph.contacts.map((contact) => {
									const Icon = getVaultContactIconFromUrl(contact.link);

									return (
										<span
											key={contact.name}
											className="flex items-center gap-1 typo-t4"
										>
											<Link
												key={contact.name}
												className="typo-t4"
												href={contact.link}
												leftIcon={Icon}
												rightIcon="none"
												openInNewTab
											>
												{contact.name}
											</Link>
										</span>
									);
								})}
							</div>
						) : paragraph.link ? (
							<div className="flex">
								<Link
									className="typo-t4"
									href={paragraph.link}
									variant="secondary"
									rightIcon={Open}
									openInNewTab
								>
									{paragraph.text}
								</Link>
							</div>
						) : typeof paragraph.text === 'string' ? (
							paragraph.text
						) : (
							// replaces all placeholders (if any) with their dynamic values
							(paragraph.text as string[]).map((t) =>
								placeholders.some((placeholder) => t.includes(placeholder)) ? (
									<span key={t} className="text-text-default">
										{t.replace(
											new RegExp(
												`(${Object.keys(placeholdersReplacements).join('|')})`,
												'g'
											),
											(match) => placeholdersReplacements[match as Placeholders]
										)}
									</span>
								) : (
									t
								)
							)
						)}
					</span>
				))}
			</div>
		</div>
	);
};
